import type {CanvasScheduleMeetingBlock} from '../types';
import type {BlockRendererProps} from './types';

export const ScheduleMeetingBlock = ({
  block,
  actions,
}: BlockRendererProps<CanvasScheduleMeetingBlock>) => {
  const handleClick = () => {
    actions?.onScheduleClick?.({blockId: block.id, url: block.url});
  };

  return (
    <div id={`schedule-block-${block.id}`} className="py-8">
      <div className="flex flex-col items-stretch gap-4 rounded-xl bg-(--canvas-primary) px-6 py-6 md:flex-row md:items-center md:justify-between md:gap-8 md:px-8">
        <div className="min-w-0">
          {block.title && (
            <h3 className="font-serif text-base text-(--canvas-accent)">
              {block.title}
            </h3>
          )}
          {block.subtitle && (
            <p className="mt-0.5 text-xs text-(--canvas-primary-foreground) opacity-80">
              {block.subtitle}
            </p>
          )}
        </div>
        <button
          type="button"
          className="w-full rounded-sm border-2 border-white bg-white px-5 py-2 text-xs font-medium uppercase tracking-widest text-foreground ring-2 ring-white/20 ring-offset-0 transition-opacity hover:opacity-90 disabled:opacity-50 md:w-auto md:shrink-0"
          onClick={handleClick}
          disabled={!actions?.onScheduleClick}
        >
          Book a time
        </button>
      </div>
    </div>
  );
};

export const scheduleMeetingBlockConfig = {
  component: ScheduleMeetingBlock,
  isEmpty: (_block: CanvasScheduleMeetingBlock) => false,
};
